import React from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { X } from "react-feather";

const CommonModal = ({
  modalSize,
  title,
  subtitle,
  modal,
  setModal,
  children,
  footer,
  center,
  noClose,
  style,
  titleStyle,
  noAutoFocus,
  backdrop,
  customFooter,
  className,
  modalClassName,
  zIndex,
}) => (
  <Modal
    isOpen={!!modal}
    toggle={() => setModal()}
    className={`modal-${modalSize || "md"} ${
      center && "modal-dialog-centered"
    } ${className || ""}`}
    style={style}
    autoFocus={noAutoFocus ? false : undefined}
    backdrop={backdrop}
    scrollable
    modalClassName={modalClassName}
    zIndex={zIndex}
  >
    {title && (
      <div className="d-flex align-content-center align-items-center justify-content-between pl-2 pr-2 pt-2" style={titleStyle}>
        <div className="d-flex flex-column align-items-start">
          <h5 className="modal-title">{title}</h5>
          {subtitle && (
            <p
              className="text-secondary"
              style={{ fontSize: "0.8rem", marginBottom: "0" }}
            >
              {subtitle}
            </p>
          )}
        </div>
        {!noClose && (
          <div className="font-weight-bold cursor-pointer">
            <X
              size="20"
              onClick={() => setModal()}
              className="font-weight-bold cursor-pointer"
            />
          </div>
        )}
      </div>
    )}
    {customFooter ? children : <ModalBody>{children}</ModalBody>}
    {footer && <ModalFooter>{footer}</ModalFooter>}
  </Modal>
);

export default CommonModal;
